import {
    CreatePageArgs as CreatePageSdkArgs,
    ImportPageArgs as ImportPageSdkArgs,
    UploadDocArgs as UploadDocData,
} from '~shared/schema/wiki/actions/create-page';

import {PageDetailsField} from '~shared/models';

import {
    createPage as createPageBase,
    importPage as importPageBase,
    getPageDetailsById,
} from '~ui/services/pages';

import {createThunk} from '../utils';

interface DeletePageThunkArgs {
    pageId: number;
    redirectSlug: string;
    slug: string;
}

export const deletePage = createThunk('pages/delete', ({pageId}: DeletePageThunkArgs, thunkAPI) => {
    const {sdk} = thunkAPI.extra;
    return sdk.wiki.deletePage({pageId});
});

export interface CreatePageData extends CreatePageSdkArgs {
    parentSlug: string;
}

export const createPage = createThunk('pages/create', (data: CreatePageData, thunkAPI) => {
    return thunkAPI.extra.sdk.wiki.createPage(data);
});

export interface GetPageDetailsByIdArgs<
    Fields extends readonly PageDetailsField[] = PageDetailsField[],
> {
    id: number;
    fields?: Fields;
    raiseOnRedirect?: boolean;
    revisionId?: number;
}

export const detailsFields = [
    PageDetailsField.Breadcrumbs,
    PageDetailsField.Content,
    PageDetailsField.Access,
    PageDetailsField.Attributes,
    PageDetailsField.LastRevisionId,
    PageDetailsField.Authors,
    PageDetailsField.Bookmark,
    PageDetailsField.Cluster,
    PageDetailsField.Subscription,
    PageDetailsField.Permissions,
] as const;

export const createPageWithDetails = createThunk(
    'pages/create-with-details',
    (data: CreatePageData) => {
        return createPageBase({...data, fields: detailsFields});
    },
);

export const getPageByIdWithDetails = createThunk(
    'pages/get-by-id-with-details',
    (data: GetPageDetailsByIdArgs) => {
        return getPageDetailsById({...data, fields: detailsFields, pageId: data.id});
    },
);

export const uploadDoc = createThunk('pages/upload', (data: UploadDocData, thunkAPI) => {
    return thunkAPI.extra.sdk.wiki.uploadDoc(data);
});

interface ImportPageData extends ImportPageSdkArgs {
    parentSlug: string;
}

export const importPage = createThunk('pages/import', (data: ImportPageData, thunkAPI) => {
    return thunkAPI.extra.sdk.wiki.importPage(data);
});

export const importPageWithDetails = createThunk(
    'pages/import-with-details',
    (data: ImportPageData) => {
        return importPageBase({...data, fields: detailsFields});
    },
);
